// import { getStravaActivitiesFinish } from "store/actions/strava";
import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  profileImage: null,
  firstName: null,
  lastName: null,
  city: null,
  activities: { items: [] },
  athlete: null,
  loading: false,
  error: false,
};

const getStravaActivitiesStart = (state) => {
  return updateObject(state, { error: null, loading: true });
};

const getStravaActivitiesSuccess = (state, action) => {
  return updateObject(state, {
    activities: action.activities,
    error: null,
    loading: false,
  });
};

const getStravaAthleteSuccess = (state, action) => {
  return updateObject(state, {
    athlete: action.athlete,
    error: null,
    loading: false,
  });
};

const getStravaActivitiesFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const getStravaActivitiesFinish = (state) => {
  return updateObject(state, { error: null, loading: false });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STRAVA_GET_AUTH_CODE_START:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.STRAVA_GET_AUTH_CODE_SUCCESS:
      return {
        ...state,
        accessToken: action.accessToken,
        refreshToken: action.refreshToken,
        profileImage: action.profileImage,
        firstName: action.firstName,
        lastName: action.lastName,
        city: action.city,
        loading: false,
      };
    case actionTypes.STRAVA_GET_AUTH_CODE_FINISH:
      return {
        ...state,
        loading: true,
      };

    case actionTypes.STRAVA_GET_ACTIVITIES_SUCCESS:
      return getStravaActivitiesSuccess(state, action);
    case actionTypes.STRAVA_GET_ATHLETE:
      return getStravaAthleteSuccess(state, action);
    case actionTypes.STRAVA_GET_ACTIVITIES_FINISH:
      return getStravaActivitiesFinish(state, action);
    case actionTypes.STRAVA_GET_ACTIVITIES_START:
      return getStravaActivitiesStart(state, action);
    default:
      return state;
  }
};

export default reducer;
